var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.6667 8.00033H48V2.66699H42.6667V8.00033H21.3333V2.66699H16V8.00033H13.3333C10.4 8.00033 8 10.4003 8 13.3337V50.667C8 53.6003 10.4 56.0003 13.3333 56.0003H50.6667C53.6 56.0003 56 53.6003 56 50.667V13.3337C56 10.4003 53.6 8.00033 50.6667 8.00033ZM50.6667 50.667H13.3333V24.0003H50.6667V50.667ZM13.3333 18.667V13.3337H50.6667V18.667H13.3333ZM28.16 46.5603L43.9733 30.747L41.1467 27.9203L28.16 40.907L22.5333 35.2803L19.7067 38.107L28.16 46.5603Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvents);
export default __webpack_public_path__ + "static/media/events.f9cbb0b5.svg";
export { ForwardRef as ReactComponent };